var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"full-height",style:(_vm.theme)},[_c('verifier-page',{on:{"toggle-change":_vm.onToggleChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }